import { Box, Hidden } from 'braid-design-system';
import {
  EmployerFooter,
  EmployerHeader,
  type EmployerSiteName,
} from '@seek/adv-header-footer';
import { Environment } from '../types';
import type { Locale } from '@seek/melways-sites';
import type { HeaderFooterContext } from './generated/graphql-types';

interface Props {
  headerFooterContext?: HeaderFooterContext;
  site: EmployerSiteName;
  locale: Locale;
  environment: Environment;
  children: any;
}

const MainLayout = ({
  headerFooterContext,
  site,
  locale,
  environment,
  children,
}: Props) => {
  const advertiser = headerFooterContext?.advertiser
    ? {
        ...headerFooterContext.advertiser,
        // Had to force cast to any[] because of a type mismatch
        permissions: headerFooterContext.advertiser?.permissions as any[],
      }
    : undefined;

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="flexStart"
        style={{ minHeight: '100vh' }}
      >
        <Hidden print>
          <EmployerHeader
            identityContext={headerFooterContext?.identityContext}
            user={headerFooterContext?.user}
            advertiser={advertiser}
            isStaging={environment !== Environment.PROD}
            site={site}
            locale={locale}
          />
        </Hidden>
        <Box
          data-testid="main-content"
          position="relative"
          flexGrow={1}
          background="surface"
        >
          {children}
        </Box>
        <Hidden print>
          <EmployerFooter
            advertiser={advertiser}
            identityContext={headerFooterContext?.identityContext}
            isStaging={environment !== Environment.PROD}
            site={site}
            locale={locale}
          />
        </Hidden>
      </Box>
    </>
  );
};
export default MainLayout;
